import '../reset.css';
import '../style.css';
import '../styles/prepclub.css';

import 'survey-core/survey-core.min.css';
import {userBrowserId} from '../scripts/common.js';
import {getTimeZone} from './_common/helpers.js';
import {initIframeResize} from './_inIFrame.js';

// import {Model} from 'survey-core';
// import {Survey} from 'survey-js-ui';
//
// import {surveyJson} from './apply/_prepclub_form.js';
// import {themeJson} from './apply/_formStyles.js';


initIframeResize();

// Registration for prep clubs is closed for the current academic year.
// Keep the form setup in comments so it can be restored when enrollment reopens.
// const survey = new Model(surveyJson);
// survey.applyTheme(themeJson);

const storageName = "TLF_clubs";
const keyAlreadyApplied = "TLF_clubs_apply_success";

const changeTimestamps = {};
let initalPhaseDone = false;


function getAlreadyApplied() {
  // Сначала читаем его из куки
  let already = window.localStorage.getItem(keyAlreadyApplied);
  let email, surname, name;
  try {
    already = JSON.parse(atob(already));
    email = already.email;
    surname = already.surname;
    name = already.name;
  } catch (error) {
    return undefined;
  }
  if (email && email.length >= 3 && surname && surname.length >= 1 && name && name.length >= 1) {
    return {email, surname, name};
  } else {
    return undefined;
  }
}

function setAlreadyApplied(email, surname, name) {
  const obj = {email, surname, name};
  const objEnc = btoa(JSON.stringify(obj));
  window.localStorage.setItem(keyAlreadyApplied, objEnc);
}

function sendDataToServer(survey, completed = false, options = null) {
  //send Ajax request to your web server
  const res = JSON.stringify({data: survey.data, changeTimestamps, id: userBrowserId, completed, tz: getTimeZone()});
  if (completed) {
    options.showDataSaving(`Submitting your data...Please wait while we send your information to the server. This will only take a moment.`);
    survey.data.full = 'yes';
  }//you may pass a text parameter to show your own text
  fetch(`${BACKEND_URL}/api/prepclubform`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: res, // Преобразуем тело запроса в JSON-строку
  })
    .then(response => {
      if (response.status === 201) {
        if (completed) {
          try {
            setAlreadyApplied(survey.data.email, survey.data.surname, survey.data.name);
          } catch (e) {
            console.error(e.toString());
          }
          clearStorage();
          // options.showDataSavingSuccess('Success! Your data has been saved successfully...');
        }
      } else {
        throw new Error(`Server responded with status ${response.status}`);
      }
    })
    .catch(error => {
      if (completed) {
        options.showDataSavingError(`Oops! Something went wrong. Your data couldn’t be saved on the server, but don’t worry—it has been stored in your browser. Please try resubmitting it. If it doesn’t work now, you can try again later. Thank you for your patience!`);
      }
      console.error('Error:', error);
    });
}

function saveState(survey) {
  let data = survey.data;
  if (Object.keys(data).length === 0) {
    const storageSt = window.localStorage.getItem(storageName) || "";
    if (storageSt) data = JSON.parse(storageSt);
  }
  const res = {currentPageNo: survey.currentPageNo, data, changeTimestamps};
  //Here should be the code to save the data into your database
  window.localStorage.setItem(storageName, JSON.stringify(res));
}

function loadState(survey) {
  //Here should be the code to load the data from your database
  const storageSt = window.localStorage.getItem(storageName) || "";
  let res = {};
  if (storageSt) res = JSON.parse(storageSt);
  //Set the loaded data into the survey.
  if (res.data) survey.data = res.data;
  if (res.currentPageNo) survey.currentPageNo = res.currentPageNo;
  // if (res.changeTimestamps) changeTimestamps = res.changeTimestamps;
}

function clearStorage() {
  window.localStorage.removeItem(storageName);
}

// document.addEventListener('DOMContentLoaded', () => {
//   const formContainer = document.getElementById('application-form');
//   if (formContainer) {
//     loadState(survey);
//     initalPhaseDone = true;
//
//     survey.onValueChanged.add(function (survey, options) {
//       // const fieldName = options.name;
//       // if (changeTimestamps[fieldName] === undefined) changeTimestamps[fieldName] = [];
//       // changeTimestamps[fieldName].push(new Date().getTime());
//       saveState(survey);
//     });
//     survey.onCurrentPageChanged.add(function (survey, options) {
//       if (initalPhaseDone) {
//         saveState(survey);
//       }
//     });
//     survey.onPartialSend.add(function (survey, options) {
//       saveState(survey);
//     });
//     survey.onComplete.add(function (survey, options) {
//       saveState(survey);
//       sendDataToServer(survey, true, options);
//     });
//
//     survey.render(formContainer);
//   } else {
//     console.error('Element #application-form not found');
//   }
// });
//
//
// document.addEventListener('DOMContentLoaded', () => {
//   const data = getAlreadyApplied();
//   if (data) {
//     const container = document.getElementById('already-applied-message');
//     if (container) {
//       container.innerHTML = `
//           <div class="bg-green-100 border border-green-300 text-green-800 p-4 mb-4 rounded">
//             <p>
//               Your application for preparation clubs has already been successfully saved under the name
//               <strong>${data.name} ${data.surname}</strong> with the email address
//               <strong>${data.email}</strong>. However, if you wish, you're welcome to submit another application.
//             </p>
//           </div>
//         `;
//     }
//   }
// });
